import { TAB_NUMBER } from '../../constants';
import { Inactive } from './Inactive/Inactive';
import { Active } from './Active/Active';
import { Completed } from './Completed/Completed';

export const TabsRouter = ({ active }: { active: number }) => {
  if (active === TAB_NUMBER.INACTIVE) {
    return <Inactive />;
  }

  if (active === TAB_NUMBER.ACTIVE) {
    return <Active />;
  }

  if (active === TAB_NUMBER.COMPLETED) {
    return <Completed />;
  }

  return null;
};
